import {
    base
} from '../path'

const basePath = base.concat('/graphics')

const path = {
    absenceSender: basePath.concat('/absence-sender')
    ,typesAbsenteeism: basePath.concat('/types-absenteeism')
    ,diagnosticGroups:  basePath.concat('/diagnostic-groups')
    ,employees: basePath.concat('/employees')
    ,timeOfAbsences: basePath.concat('/times-of-absences')
}

export {
    path
}